"use strict";

export function initInScope ($scope) {
    $scope.find('.js-back-button').on('click', function (e) {
        e.preventDefault();
        history.back(1);
    });
}
